import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { locale } from "../../../shared/locale/locale.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface StringChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-locale-select",
  templateUrl: "./locale-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class LocaleSelectComponent implements OnInit {
  public readonly localeChange = output<string>();
  @Input() public locale = "Please select language";
  public readonly showMain = input(false);
  public readonly showClear = input(false);

  public subscription = new Subscription();
  public localeList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildLocaleList();
  }

  public onLocaleChange(event: StringChangeEvent) {
    this.localeChange.emit(event.value);
  }

  private buildLocaleList() {
    if (this.showMain()) {
      this.localeList.push({
        label: "Main",
        value: "main",
      });
    }
    Object.keys(locale).map((key) => {
      this.localeList.push({
        label: locale[key].name,
        value: locale[key].code,
      });
    });
  }
}
